import { Trans, useTranslation } from 'react-i18next';

import type { CalendarEvent } from 'src/Components/Calendars/MonthCalendar/MonthCalendar.types';
import { FALLBACK_HOUSEHOLD_COLOR, getEventVisual } from 'src/Utils/eventVisuals';

import styles from '../ListCalendar.module.scss';

interface Props {
  stay: CalendarEvent;
  onClick: (event: CalendarEvent) => void;
}

const OngoingStayBanner = ({ stay, onClick }: Props) => {
  const { i18n } = useTranslation();
  const visual = getEventVisual(stay);

  return (
    <button className={styles.ongoingBanner} onClick={() => onClick(stay)} type="button">
      <span
        className={styles.ongoingDot}
        style={{ backgroundColor: visual.color ?? FALLBACK_HOUSEHOLD_COLOR }}
      >
        {visual.initial}
      </span>
      <span className={styles.ongoingText}>
        <Trans
          i18nKey="planning.listView.ongoing"
          defaults="En ce moment à la maison : <b>{{household}}</b>, jusqu’au {{date}}"
          values={{
            household: visual.label,
            date: stay.endTime?.locale(i18n.language).format('D MMM') ?? '',
          }}
          components={{ b: <strong /> }}
        />
      </span>
    </button>
  );
};

export default OngoingStayBanner;
